import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const fmt = (iso) => (iso ? `${iso.slice(0, 10)} ${iso.slice(11, 16)}` : "—");

export const RMEmailLog = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/admin/rms/email-log", { params: { limit: 200 } })
      .then((r) => setItems(r.data.items || []))
      .catch(() => toast.error("Couldn't load the email log"));
  }, []);

  return (
    <div data-testid="rm-email-log">
      <p className="text-sm text-neutral-400">Intro emails sent to clients and fortnightly check-in reminders sent to capital@clinq.africa.</p>
      <div className="mt-4 overflow-x-auto rounded-2xl border border-neutral-800">
        <table className="w-full min-w-[820px] text-left text-sm" data-testid="rm-email-log-table">
          <thead className="bg-neutral-900 text-[10px] uppercase tracking-wider text-neutral-400">
            <tr>
              <th className="px-3 py-3">Sent</th>
              <th className="px-3 py-3">Type</th>
              <th className="px-3 py-3">Client / Company</th>
              <th className="px-3 py-3">RM</th>
              <th className="px-3 py-3">Recipient</th>
              <th className="px-3 py-3">Subject</th>
              <th className="px-3 py-3">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-neutral-800 bg-neutral-950">
            {items === null ? (
              <tr><td colSpan={7} className="px-4 py-10 text-center text-neutral-500">Loading…</td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan={7} className="px-4 py-10 text-center text-neutral-500" data-testid="rm-email-log-empty">No RM emails sent yet.</td></tr>
            ) : items.map((e, i) => (
              <tr key={`${e.sent_at}-${i}`} data-testid={`rm-email-log-row-${i}`}>
                <td className="px-3 py-2.5 text-xs text-neutral-300">{fmt(e.sent_at)}</td>
                <td className="px-3 py-2.5">
                  <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase ${
                    e.type === "intro" ? "bg-teal-500/10 text-teal-300" : "bg-amber-500/10 text-amber-300"}`}>
                    {e.type === "intro" ? "Intro" : "Reminder"}
                  </span>
                </td>
                <td className="px-3 py-2.5 text-xs">
                  <p className="font-semibold text-neutral-100">{e.client_name}</p>
                  <p className="text-[11px] text-neutral-500">{e.company_name}</p>
                </td>
                <td className="px-3 py-2.5 text-xs text-neutral-300">{e.rm_name}</td>
                <td className="px-3 py-2.5 text-xs text-neutral-400">{e.to}</td>
                <td className="px-3 py-2.5 text-xs text-neutral-400">{e.subject}</td>
                <td className="px-3 py-2.5">
                  {e.ok
                    ? <span className="text-xs font-semibold text-emerald-400">Sent</span>
                    : <span className="text-xs font-semibold text-red-400">Failed</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
